
  window.NadosCart = (function () {
    var artikel = {};
    var schub, hinter, liste, hinweis, elZwischen, elGesamt;

    function euro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }
    function alsZahl(p) {
      var n = parseFloat(String(p).replace(/[^0-9,.\-]/g, '').replace(',', '.'));
      return isNaN(n) ? null : n;
    }

    function fliegen(startEl) {
      var ziel = document.getElementById('cart-btn');
      if (!startEl || !ziel) return;
      var s = startEl.getBoundingClientRect();
      var z = ziel.getBoundingClientRect();
      var punkt = document.createElement('span');
      punkt.className = 'fly-dot';
      punkt.style.left = (s.left + s.width / 2 - 6) + 'px';
      punkt.style.top = (s.top + s.height / 2 - 6) + 'px';
      punkt.style.setProperty('--fly-x1', ((z.left + z.width / 2) - (s.left + s.width / 2)) + 'px');
      punkt.style.setProperty('--fly-y1', ((z.top + z.height / 2) - (s.top + s.height / 2)) + 'px');
      document.body.appendChild(punkt);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { punkt.classList.add('fly-dot-go'); });
      });
      setTimeout(function () {
        punkt.remove();
        var badge = document.getElementById('cart-badge');
        if (badge) { badge.classList.remove('bump'); void badge.offsetWidth; badge.classList.add('bump'); }
      }, 560);
    }

    function bauen() {
      if (document.getElementById('cart-drawer')) return;

      hinter = document.createElement('div');
      hinter.className = 'cart-backdrop';
      document.body.appendChild(hinter);

      schub = document.createElement('aside');
      schub.className = 'cart-drawer';
      schub.id = 'cart-drawer';
      schub.setAttribute('aria-label', 'Warenkorb');
      schub.innerHTML =
        '<div class="cart-titelzeile">' +
          '<p class="cart-titel">' + esc(NadosT('Dein Warenkorb')) + '</p>' +
          '<button type="button" class="cart-info" aria-label="Abholung oder Lieferung ändern">' +
            '<span class="cart-info-modus">' + esc(NadosT('Abholung')) + '</span>' +
            '<span class="cart-info-zeit">' + esc(NadosT('Termin wählen')) + '</span>' +
          '</button>' +
        '</div>' +
        '<div class="cart-note" hidden>' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A2BE2" stroke-width="2.6" ' +
          'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>' +
          '<span>' + esc(NadosT('Der Artikel wurde erfolgreich in den Warenkorb gelegt')) + '</span>' +
        '</div>' +
        '<div class="cart-body"></div>' +
        '<div class="cart-summe">' +
          '<div class="cart-zeile cart-warenwert"><span>' + esc(NadosT('Warenwert:')) + '</span><span class="cart-wert-zwischen">–</span></div>' +
          '<div class="cart-zeile cart-liefer" hidden><span>' + esc(NadosT('Lieferkosten:')) + '</span><span class="cart-wert-liefer">–</span></div>' +
          '<div class="cart-zeile cart-gesamt"><span>' + esc(NadosT('Gesamtsumme:')) + '</span><span class="cart-wert-gesamt">[Gesamtsumme]</span></div>' +
          '<p class="cart-mwst">' + esc(NadosT('*inkl. MwSt.')) + '</p>' +
        '</div>' +
        '<div class="cart-aktionen">' +
          '<button type="button" class="btn cart-kasse">' + esc(NadosT('Zur Kasse')) + '<span class="cart-chevron" aria-hidden="true">›</span></button>' +
          '<p class="cart-hinweis">[Platzhalter &ndash; Kasse ist noch nicht angebunden.]</p>' +
        '</div>' +
        '<div class="cart-head">' +
          '<button type="button" class="cart-back"><span aria-hidden="true">‹</span>' + esc(NadosT('Weiter einkaufen')) + '</button>' +
        '</div>';
      document.body.appendChild(schub);

      liste = schub.querySelector('.cart-body');
      hinweis = schub.querySelector('.cart-note');
      elZwischen = schub.querySelector('.cart-wert-zwischen');
      elGesamt = schub.querySelector('.cart-wert-gesamt');

      schub.querySelector('.cart-back').addEventListener('click', schliessen);


      // Klick auf die Abhol-Info springt zu den Abholfeldern
      schub.querySelector('.cart-info').addEventListener('click', function () {
        var ziel = document.querySelector('.fulfillment-row');
        if (!ziel) return;
        if (location.hash !== '#donuts') location.hash = 'donuts';
        setTimeout(function () {
          var r = ziel.getBoundingClientRect();
          window.scrollTo(0, Math.max(r.top + (window.pageYOffset || 0) - 120, 0));
        }, 60);
        if (!angedockt()) schliessen();
      });
      infoAktualisieren();
      document.addEventListener('click', function () { setTimeout(infoAktualisieren, 0); });
      document.addEventListener('nados:lang', infoAktualisieren);
      hinter.addEventListener('click', schliessen);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') schliessen();
      });
    }

    // Am Desktop ist der Warenkorb auf der Donuts-Seite fest rechts angedockt
    function angedockt() {
      return document.body.classList.contains('page-donuts') &&
        !!(window.matchMedia && window.matchMedia('(min-width: 1100px)').matches);
    }
    function infoAktualisieren() {
      if (!schub) return;
      var aktiv = document.querySelector('.fulfillment-option.active');
      var modus = aktiv ? aktiv.getAttribute('data-fulfillment') : 'abholung';
      var d = document.getElementById('abholdatum'), z = document.getElementById('abholuhrzeit');
      var t = function (x) { x = window.NadosT ? NadosT(x) : x; return window.NadosI18n ? window.NadosI18n.t(x) : x; };
      var zeit;
      if (d && d.value && z && z.value) zeit = d.value + ' \u00b7 ' + z.value;
      else if (d && d.value) zeit = d.value;
      else zeit = t('Termin wählen');
      var elM = schub.querySelector('.cart-info-modus'), elZ = schub.querySelector('.cart-info-zeit');
      var m = t(modus === 'lieferung' ? 'Lieferung' : 'Abholung');
      if (elM.textContent !== m) elM.textContent = m;
      if (elZ.textContent !== zeit) elZ.textContent = zeit;
      summen();
    }
    function oeffnen(mitHinweis) {
      bauen();
      if (hinweis) hinweis.hidden = !mitHinweis;
      if (mitHinweis) { clearTimeout(oeffnen.t); oeffnen.t = setTimeout(function () { if (hinweis) hinweis.hidden = true; }, 4000); }
      infoAktualisieren();
      if (angedockt()) return;          // angedockt: ist schon sichtbar
      schub.classList.add('open');
      hinter.classList.add('open');
    }
    function schliessen() {
      if (!schub) return;
      schub.classList.remove('open');
      hinter.classList.remove('open');
    }

    var MUELLEIMER_SVG = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/><path d="M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>';

    function zeichne() {
      var badge = document.getElementById('cart-badge');
      var anzahl = 0;
      Object.keys(artikel).forEach(function (id) { anzahl += artikel[id].menge; });
      if (badge) {
        badge.textContent = anzahl;
        badge.style.display = anzahl > 0 ? 'flex' : 'none';
      }
      if (!liste) return;

      var ids = Object.keys(artikel);
      if (!ids.length) {
        liste.innerHTML = '<p class="cart-empty">' + esc(NadosT('Dein Warenkorb ist leer.')) + '</p>';
      } else {
        liste.innerHTML = ids.map(function (id) {
          var a = artikel[id];
          var bild = a.bild ? '<img src="' + a.bild + '" alt="">' : '<span class="cart-item-platz"></span>';
          return '<div class="cart-item-row">' + bild +
            '<span class="cart-item-text">' +
            '<span class="cart-item-name"><span>' + esc(a.name) + '</span>' + (a.details ? '<br><small><span class="nd-sorten-label">' + esc(NadosT('Sorten:')) + '</span> ' + String(a.details).split(/,\s*(?=\d+\s*\u00d7)/).map(function (x) { return '<span class="nd-sorte-zeile">' + esc(x.trim()) + '</span>'; }).join('<span class="nd-sorte-trenner">, </span>') + '</small>' : '') + '</span>' +
            '<span class="cart-item-controls">' +
              '<button type="button" class="qty-btn" data-decrease="' + id + '" aria-label="Menge verringern">–</button>' +
              '<span class="cart-item-qty">' + a.menge + '</span>' +
              '<button type="button" class="qty-btn" data-increase="' + id + '" aria-label="Menge erh\u00f6hen">+</button>' +
              '<span class="cart-item-preis">' + (alsZahl(a.preis) === null ? a.preis + ' €' : euro(alsZahl(a.preis) * a.menge)) + '</span>' +
            '</span></span>' +
            '<button type="button" class="cart-item-delete" data-remove="' + id + '" aria-label="Entfernen">' + MUELLEIMER_SVG + '</button></div>';
        }).join('');
      }

      var summe = 0, bekannt = ids.length > 0;
      ids.forEach(function (id) {
        var n = alsZahl(artikel[id].preis);
        if (n === null) bekannt = false; else summe += n * artikel[id].menge;
      });
      if (elZwischen) elZwischen.textContent = bekannt ? euro(summe) : '[Preis eintragen]';
      summen();
    }
    // Lieferkosten: bei Lieferung eigene Zeile, Gesamtsumme = Warenwert + Lieferkosten
    function lieferModus() {
      var aktiv = document.querySelector('.fulfillment-option.active');
      if (aktiv) return aktiv.getAttribute('data-fulfillment') === 'lieferung';
      return shopArt === 'Lieferung';
    }
    function lieferKosten() {
      var v = (window.NadosTexte || {}).__liefer_kosten;
      var k = parseFloat(String(v == null ? '' : v).replace(',', '.'));
      return (isNaN(k) || k < 0) ? 0 : k;
    }
    function summen() {
      if (!schub) return;
      var k = (lieferModus() && Object.keys(artikel).length) ? lieferKosten() : 0;
      var zeile = schub.querySelector('.cart-liefer');
      if (zeile) {
        if (zeile.hidden !== !(k > 0)) zeile.hidden = !(k > 0);
        zeile.style.setProperty('display', k > 0 ? 'flex' : 'none', 'important');   // gegen die ausgeblendete Zwischensumme
        var w = zeile.querySelector('.cart-wert-liefer'), t = euro(k);
        if (w && w.textContent !== t) w.textContent = t;
      }
      if (elZwischen && SHOP && shopGesamt !== null) { var zw = euro(shopGesamt / 100); if (elZwischen.textContent !== zw) elZwischen.textContent = zw; }
      if (elGesamt) {
        var g = (SHOP && shopGesamt !== null) ? euro(shopGesamt / 100 + k) : '[Gesamtsumme]';
        if (elGesamt.textContent !== g) elGesamt.textContent = g;
      }
    }

    // ---- Shopify-Anbindung: im Shop laeuft der Warenkorb ueber die Ajax Cart API,
    //      in der lokalen Vorschau (kein window.Shopify) bleibt alles wie bisher ----
    var SHOP = !!(window.Shopify && window.fetch && window.JSON);
    var shopGesamt = null, shopArt = '';
    function shopRoot() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
    function shopFetch(pfad, daten) {
      var opt = { credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
      if (daten) { opt.method = 'POST'; opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(daten); }
      return fetch(shopRoot() + pfad, opt).then(function (r) {
        if (!r.ok) throw new Error('Shopify ' + r.status);
        return r.json();
      });
    }
    function ausShopify(cart) {
      artikel = {};
      (cart.items || []).forEach(function (it) {
        var pr = it.properties || {};
        if (it.product_type === 'Versandart') return;     // 0-€-Platzhalter Abholung/Lieferung (nados-versandart.js)
        if (pr['_box']) {                              // Sorten einer Box zu einer Zeile zusammenfassen
          var gk = {}; Object.keys(pr).forEach(function (k) { if (k !== '_stk') gk[k] = pr[k]; });
          var gid = 'box-' + hash(JSON.stringify(gk)), stk = parseInt(pr['_stk'], 10) || 1;
          var g = artikel[gid] || (artikel[gid] = { name: pr['Box'] || '', cents: 0, bild: pr['_bild'] || it.image || '', teile: [], menge: null, shop: true, gruppe: true });
          g.teile.push({ key: it.key, stk: stk, name: it.product_title || it.title || '' });
          g.cents += it.final_price * stk;
          var m = Math.floor(it.quantity / stk);
          g.menge = (g.menge === null) ? m : Math.min(g.menge, m);
          return;
        }
        artikel[it.key] = {
          name: it.product_title || it.title || '',
          preis: (it.final_price / 100).toFixed(2).replace('.', ','),
          bild: it.image || '',
          details: (it.properties && it.properties['Sorten']) || '',
          menge: it.quantity, shop: true
        };
      });
      Object.keys(artikel).forEach(function (id) {
        var a = artikel[id];
        if (!a.gruppe) return;
        a.menge = Math.max(a.menge || 0, 1);
        a.preis = (a.cents / 100).toFixed(2).replace('.', ',');
        a.details = a.teile.map(function (t) { return t.stk + '\u00d7 ' + t.name; }).join(', ');
      });
      shopGesamt = (typeof cart.total_price === 'number') ? cart.total_price : null;
      shopArt = (cart.attributes && cart.attributes.Versandart) || '';
      zeichne();
    }
    function boxMenge(id, n) {
      var up = {};
      artikel[id].teile.forEach(function (t) { up[t.key] = Math.max(0, n) * t.stk; });
      return shopFetch('cart/update.js', { updates: up }).then(ausShopify).catch(shopLaden);
    }
    function shopLaden() { return shopFetch('cart.js').then(ausShopify).catch(function () {}); }
    function shopMenge(key, menge) {
      return shopFetch('cart/change.js', { id: key, quantity: Math.max(0, menge) }).then(ausShopify).catch(shopLaden);
    }
    // Artikel mit Shopify-Varianten-ID hinzufuegen (anzeige = Daten fuer die lokale Vorschau)
    function varianteHinzufuegen(varianteId, menge, props, anzeige) {
      anzeige = anzeige || {};
      if (!SHOP) {
        hinzufuegen(anzeige.id || varianteId, anzeige.name || '', anzeige.preis || '', anzeige.bild || '', anzeige.details || '', menge);
        return;
      }
      shopFetch('cart/add.js', { items: [{ id: Number(varianteId), quantity: menge || 1, properties: props || {} }] })
        .then(shopLaden)
        .catch(shopLaden);
    }

    // Mehrere Artikel auf einmal (Box aus Sorten-Produkten); items: [{id, quantity, properties, anzeige}]
    function artikelHinzufuegen(items) {
      if (!items || !items.length) return;
      if (!SHOP) {
        items.forEach(function (it) { var a = it.anzeige || {}; hinzufuegen(a.id || it.id, a.name || '', a.preis || '', a.bild || '', a.details || '', it.quantity); });
        return;
      }
      shopFetch('cart/add.js', { items: items.map(function (it) { return { id: Number(it.id), quantity: it.quantity || 1, properties: it.properties || {} }; }) })
        .then(shopLaden)
        .catch(shopLaden);
    }

    // Box aus Sorten-Produkten: b = { id, name, bild, cents, details, qty, props, teile: [{ variant, stk }] }
    function boxHinzufuegen(b) {
      if (!b || !b.teile || !b.teile.length) return;
      var key = (b.id || '') + '|' + b.teile.map(function (t) { return t.variant + ':' + t.stk; }).join(',');
      var menge = b.qty || 1;
      if (!SHOP) { hinzufuegen(key, b.name || '', ((b.cents || 0) / 100).toFixed(2).replace('.', ','), b.bild || '', b.details || '', menge); return; }
      var items = b.teile.map(function (t) {
        var p = {}; Object.keys(b.props || {}).forEach(function (k) { p[k] = b.props[k]; });
        p['Box'] = b.name || ''; p['_box'] = key; p['_stk'] = String(t.stk);
        if (b.bild) p['_bild'] = b.bild;
        return { id: Number(t.variant), quantity: t.stk * menge, properties: p };
      });
      shopFetch('cart/add.js', { items: items }).then(shopLaden).catch(shopLaden);
    }
    // Daten einer Box-Karte (fester Inhalt aus data-teile / data-inhalt)
    function boxAusKarte(karte, menge, props) {
      var teile = [];
      String(karte.getAttribute('data-teile') || '').split(',').forEach(function (t) {
        var m = /^\s*(\d+)\s*:\s*(\d+)\s*$/.exec(t);
        if (m) teile.push({ variant: m[1], stk: parseInt(m[2], 10) });
      });
      var details = String(karte.getAttribute('data-inhalt') || '').split(',').map(function (t) {
        var m = /^\s*(.+?)\s*:\s*(\d+)\s*$/.exec(t);
        return m ? m[2] + '\u00d7 ' + m[1] : '';
      }).filter(Boolean).join(', ');
      var img = karte.querySelector('.box-card-media img');
      return { id: karte.getAttribute('data-box-id') || '', name: karte.getAttribute('data-name') || '',
        bild: img ? (img.getAttribute('src') || '') : '', cents: parseInt(karte.getAttribute('data-price-cents') || '0', 10) || 0,
        details: details, qty: menge || 1, props: props || {}, teile: teile };
    }

    function hash(s) { var h = 5381; for (var i = 0; i < s.length; i++) { h = ((h << 5) + h + s.charCodeAt(i)) | 0; } return Math.abs(h).toString(36); }
    function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    function hinzufuegen(id, name, preis, bild, details, menge) {
      bauen();
      var key = details ? id + '-' + hash(details) : id;
      if (!artikel[key]) artikel[key] = { name: name, preis: preis, bild: bild || '', details: details || '', menge: 0 };
      artikel[key].menge += (menge || 1);
      zeichne();
    }
    function mengeAendern(id, delta) {
      if (!artikel[id]) return;
      if (artikel[id].gruppe) { boxMenge(id, artikel[id].menge + delta); return; }
      if (artikel[id].shop) { shopMenge(id, artikel[id].menge + delta); return; }
      artikel[id].menge += delta;
      if (artikel[id].menge <= 0) delete artikel[id];
      zeichne();
    }
    function entfernen(id) {
      if (artikel[id] && artikel[id].gruppe) { boxMenge(id, 0); return; }
      if (artikel[id] && artikel[id].shop) { shopMenge(id, 0); return; }
      delete artikel[id];
      zeichne();
    }

    document.addEventListener('click', function (e) {
      var weg = e.target.closest && e.target.closest('[data-remove]');
      if (weg) { entfernen(weg.getAttribute('data-remove')); return; }
      var minus = e.target.closest && e.target.closest('[data-decrease]');
      if (minus) { mengeAendern(minus.getAttribute('data-decrease'), -1); return; }
      var plus = e.target.closest && e.target.closest('[data-increase]');
      if (plus) { mengeAendern(plus.getAttribute('data-increase'), 1); return; }
      var knopf = e.target.closest && e.target.closest('#cart-btn');
      if (knopf) {
        e.preventDefault();
        if (angedockt()) { schub.scrollTop = 0; schub.classList.remove('puls'); void schub.offsetWidth; schub.classList.add('puls'); return; }
        if (schub && schub.classList.contains('open')) schliessen(); else oeffnen(false);
      }
    });

    function start() {
      bauen(); zeichne();
      if (SHOP) {
        shopLaden();
        // Kasse: im Shop direkt zum Shopify-Checkout; Platzhalter-Hinweis nur in der Vorschau
        var kasse = schub.querySelector('.cart-kasse');
        if (kasse) kasse.addEventListener('click', function () { window.location.href = shopRoot() + 'checkout'; });
        var ph = schub.querySelector('.cart-hinweis');
        if (ph) ph.hidden = true;
      }
    }
    var api = {};
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();

    api.add = hinzufuegen; api.remove = entfernen; api.open = oeffnen; api.close = schliessen; api.fly = fliegen;
    api.docked = angedockt;
    api.addVariant = varianteHinzufuegen;
    api.addItems = artikelHinzufuegen;
    api.addBox = boxHinzufuegen;
    api.boxFromCard = boxAusKarte;
    api.info = infoAktualisieren;
    return api;
  })();
  
